import React from 'react';
import TextField from 'material-ui/TextField';

const TextInput = ({ onChange, label }) => (
  <TextField
    floatingLabelText={label}
    fullWidth={true}
    onChange={onChange}
  />
);

export default TextInput



// WEBPACK FOOTER //
// ./src/TextInput.js